<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
  <!-- Form -->
  <form @submit.prevent="store" class="form-content" style="height: 90vh">
    <div class="form-content-inner">
      <control
        type="hidden"
        v-model="programmeOwner.id"
        :hasError="!!errors.id"
        id="id"
      />
      <div class="form-col" v-if="!showEdit">
        <field
          :label="$t('programmeOwner.employee')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.employee_id"
        >
          <multiselect
            ref="employeSelect"
            v-model="selected"
            :options="employeeList"
            label="name"
            :close-on-select="false"
            :placeholder="$t('programmeOwner.placeholder.employeeselect')"
            @select="onSelect"
            mode="tags"
            trackBy="value"
            :searchable="true"
          />
        </field>
      </div>
      <div class="form-col" v-if="showEdit">
        <field
          :label="$t('programmeOwner.employee')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.employee_id"
        >
          <multiselect
            ref="employeSelect"
            v-model="programmeOwner.employee_id"
            :options="employeeList"
            label="name"
            :close-on-select="false"
            :placeholder="$t('programmeOwner.placeholder.employeeselect')"
            @select="onSelect"
            :multiple="false"
            mode="single"
            trackBy="value"
            :searchable="true"
          />
        </field>
      </div>
      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>
</template>
<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
  computed,
} from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import { useToast } from "vue-toastification";
//   import Datepicker from '@vuepic/vue-datepicker'
import "@vuepic/vue-datepicker/dist/main.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Multiselect from "@vueform/multiselect";
export default {
  name: "ClassForm",
  components: {
    Field,
    Control,
    Loading,
    JbButton,
    JbButtons,
    Multiselect,
  },
  props: {
    showEdit: { Boolean },
    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
    programmeId: {
      type: String,
      default: "",
    },
    propDepartment: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propYear: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propLevel: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit", "reset-modal"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);

    const isLoading = ref(false);

    const toast = useToast();

    const router = useRouter();

    const errors = ref([]);

    const str = useStore();
    const userlogin = localStorage.getItem("name");

    const programmeList = ref();
    const employeeList = ref();

    const programmeOwner = reactive({
      id: "",
      programme_id: "",
      employee_id: "",
    });

    const reset = () => {
      // programmeOwner.programme_id = ''
      programmeOwner.employee_id = "";
    };

    const selected = ref([]);
    const employeSelect = ref(null);

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit
        ? "programme-owner/" + programmeOwner.id
        : "programme-owner";
      const method = props.showEdit ? "PUT" : "POST";
      if (method === "POST") {
        programmeOwner.created_by = userlogin;
        programmeOwner.employee_id = selected.value;
      } else {
        programmeOwner.updated_by = userlogin;
      }
      const jsonData = JSON.stringify(programmeOwner);
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };
      await axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.messages);
          }
          isLoading.value = false;
          reset();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error);
            toast.error(error.response.data.message);
            console.log(JSON.stringify(error.request));
          } else if (error.message) {
            console.log(error.message);
            toast.error(error.message);
            console.log(JSON.stringify(error.message));
          }
          isLoading.value = false;
        });
    };

    const getProgramme = async () => {
      isLoading.value = true;
      await axios
        .get("programme")
        .then((response) => {
          programmeList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };
    const getEmployee = async () => {
      isLoading.value = true;
      const userId = localStorage.getItem('user_id')
      const branchId = localStorage.getItem('branch_id')
      const params = {
        user_id: userId,
        branch_id: branchId
      }
      await axios
        .get("employee", { params })
        .then((response) => {
          const data = response.data.data;
          employeeList.value = [
            { value: "__all__", name: "Select All" },
            ...data.map((emp) => ({
              value: emp.id,
              name: emp.name,
            })),
          ];
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const normalizedEmployees = computed(() => {
      const base = employeeList.value.map((emp) => ({
        value: emp.value, // assume API returns `id`
        name: emp.name, // and `name`
      }));
      if (programmeOwner.employee_id === "__all__") {
        return [{ value: "__all__", name: "Select All" }, ...base];
      }
      return base;
    });

    // Select All logic
    const onSelect = (option) => {
      console.log("option.value", option);
      if (option === "__all__") {
        console.log("normalizedEmployees", normalizedEmployees.value);
        selected.value = normalizedEmployees.value
          .filter((opt) => opt.value !== "__all__")
          .map((opt) => opt.value);
      }
    };

    onBeforeMount(() => {});

    onMounted(() => {
      // academicyear.value =toRefs(props, 'propClass')
      getProgramme();
      getEmployee();
    });

    watch(
      () => props.programmeId,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          programmeOwner.programme_id = newVal;
        }
      }
    );
    
    watch(
      () => props.showEdit,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          if (props.showEdit) {
            employeeList.value = normalizedEmployees.value.filter(
              (opt) => opt.value !== "__all__"
            );
          } else {
            employeeList.value = [
              { value: "__all__", name: "Select All" },
              ...normalizedEmployees.value,
            ];
          }
        }
      }
    );

    watchEffect(() => {
      const newprogrammeowner = props.propClass;
      // holidaysList.value = props.propHolidays
      if (!props.showEdit) {
        newprogrammeowner.id = null;
      }
      // if (props.propClass.is_active !== undefined) {
      //   customElementsForm.is_active = [props.propClass.is_active]
      // }
      Object.assign(programmeOwner, newprogrammeowner);
    });

    return {
      isLoading,
      titleStack,
      programmeList,
      employeeList,
      // customElementsForm,
      mdiBallot,
      mdiCheckBold,
      router,
      getProgramme,
      getEmployee,
      programmeOwner,
      store,
      toast,
      userlogin,
      errors,
      reset,
      str,
      selected,
      employeSelect,
      onSelect,
    };
  },
  methods: {
    clearForm() {
      this.programmeOwner = reactive({
        id: "",
        programme_id: "",
        employee_id: "",
        created_by: "",
      });
    },
    onChange: function (programme_id, event) {
      if (event.target.value) {
        programme_id = event.target.value;
      }
    },
  },
  // created () {
  //   this.levelListFilter = this.levelList
  //   this.academicYearListFilter = this.academicYearList
  // }
};
</script>
